export const AppBarHeight = '64px';
export const SidebarExpandWidth = 64;
